import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import NumberField from '../../../../components/forms/NumberField'
import { hasValue } from '../../../../utils/NumberUtil'
import { EVENT_ACTION } from '../../../constants/PiezometryEventConstants'
import { getTitleCard, getYesOrNo } from '../EventFormUtils'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import { SENSOR } from 'materiel/constants/MaterielConstants'
import { shallowEqual, useSelector } from 'react-redux'

const EventSensorCard = ({
    sensor = {},
    formActions = [],
    disabled = {},
    lastReplacementDate = '',
    setFormAction = () => { },
    getBooleanChoiceWithAction = () => { },
    displaySupply = true,
    hasPowerSupply = true,
}) => {
    const {
        sensorTypes,
        powerSupplyTypes,
    } = useSelector(store => ({
        sensorTypes: store.SensorReducer.sensorTypes,
        powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
    }), shallowEqual)
    const powerSupplyType = powerSupplyTypes.find(t => t.id === sensor.powerSupplyType)
    return (
        <Card>
            {getTitleCard(i18n.sensor, SENSOR, sensor, sensorTypes)}
            <CardContent>
                {
                    hasPowerSupply && (
                        <>
                            <Grid container alignItems={'center'}>
                                <Grid size={8}>
                                    {
                                        displaySupply && (
                                            <NumberField
                                                value={(formActions.find(a => a.managementRule === EVENT_ACTION.TENSION_PILES_CAPTEUR && a.materielId === sensor.id) || {}).value}
                                                title={i18n.sensorVoltage}
                                                floatValue
                                                onChange={v => setFormAction(EVENT_ACTION.TENSION_PILES_CAPTEUR, v, sensor.id, hasValue(v))}
                                                {...disabled}
                                            />
                                        )
                                    }
                                </Grid>
                                <Grid size={3} offset={1}>
                                    <Checkbox
                                        label={i18n.replacement}
                                        checked={formActions.find(a => a.managementRule === EVENT_ACTION.REMPLACEMENT_PILES_CAPTEUR && a.materielId === sensor.id)}
                                        onChange={v => setFormAction(EVENT_ACTION.REMPLACEMENT_PILES_CAPTEUR, null, sensor.id, v)}
                                        active={disabled.active}
                                        disabled={powerSupplyType?.isNotReplaceable || disabled.disabled}
                                    />
                                </Grid>
                            </Grid>
                            <Typography variant={'h6'}>{`${i18n.lastReplacement} : ${lastReplacementDate}`}</Typography>
                        </>
                    )
                }
                <Grid container>
                    <Grid size={8}>
                        <table>
                            {getYesOrNo()}
                            {getBooleanChoiceWithAction(i18n.replaceDesiccant, EVENT_ACTION.DESSICANT_REMPLACE, sensor.id, disabled)}
                        </table>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

EventSensorCard.propTypes = {
    sensor: PropTypes.object,
    formActions: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.object,
    lastReplacementDate: PropTypes.string,
    setFormAction: PropTypes.func,
    getBooleanChoiceWithAction: PropTypes.func,
    displaySupply: PropTypes.bool,
    hasPowerSupply: PropTypes.bool,
}

export default EventSensorCard